import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const SettingsFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the SettingsFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SettingsFrame;
